// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { useEffect, useState } from "react";
// import {
//   faPenToSquare,
//   faSave,
//   faCheck,
//   faXmark,
//   faFileLines,
//   faLanguage,
//   faList,
//   faEye
// } from "@fortawesome/free-solid-svg-icons";
// import Modal from "../../../components/Modal";
// import QuestionTitleTrans from "./QuestionTitleTrans";
// import QuestionSubTitleTrans from "./QuestionSubTitleTrans";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchLanguageList } from "../../../slices/panelSlice/languageSlice";
// import OptionList from "./OptionList";
// import CountryOptionList from "./CountryOptionList";
// import TempRecordPopUp from "./TempRecord";


// const EditableTable = ({
//   headers,
//   rows,
//   editRowId,
//   editedData,
//   handleEdit,
//   handleSave,
//   handleCancel,
//   handleChange,
//   editableFields,
//   handleLog,
//   optionList,
//   handleview,
//   vTypeData,
//   categoryData,
//   subCategoryData,
//   editable

// }) => {
//   const [transDis, setTransDis] = useState(false);
//   const [transData, setTransData] = useState({});
//   const [subTitleTransDis, setSubTitleTransDis] = useState(false);
//   const [optionMod, setOptionMod] = useState(false);
//   const [currOptionData, setCurrentOptionData] = useState({});
//   const languageList = useSelector((state) => state.language);
//   const dispatch = useDispatch();
//   const [cOptionsDis, setCoptionsDis] = useState(false);
//   const [currRow, setCurrRow] = useState(null);
//   const [tempRecord, setTempRecord] = useState();
//   const [tempDis, setTempDis] = useState(false);

//   const handleTranslation = (data, id) => {
//   
//     setTransData({ data, id });
//     setTransDis(true);
//   };

//   const handleSubTitleTranslation = (data, id) => {
//     setTransData({ data, id });
//     setSubTitleTransDis(true);
//   };

//   const handleOptionList = (data,id)=>{
//     setCurrentOptionData({id,data});
//     setOptionMod(true);
//   }

//   const handleCountryOptionList = (row)=>{
//     setCurrRow(row)
//     setCoptionsDis(true)
//   }

//   const handleTempRecord = (data)=>{
//     let finalObj = {id:data.id,tempData:data.Temp_Record};
//     setTempRecord(finalObj);
//     setTempDis(true);
//   }

//   useEffect(()=>{
//     dispatch(fetchLanguageList())
//   },[dispatch])

//   return (
//     <>
//       <div className="tableContainer overflow-x-auto max-h-[80vh]">
//         <table className="table text-xs w-full border-collapse">
//           <thead style={{zIndex:1}} className="sticky top-0 bg-[var(--mainCol)] text-white">
//             <tr>
//               {headers?.map((header, index) => (
//                 <th className="p-1 text-left border" key={index}>
//                   {header.toUpperCase()}
//                 </th>
//               ))}
//               {editable && 
//                <th className="p-1 text-left border bg-[var(--mainCol)] sticky right-0 z-20">ACTION</th>
//               }
             
//             </tr>
//           </thead>
//           <tbody>
//             {rows.map((row) => (
//               <tr key={row.id} className="relative">
//                 {headers.map((header) => (
//                   <td key={header} className="p-3 border text-left text-nowrap">
//                     {editRowId === row.id && editableFields.includes(header) ? (
//                       header === "variableType" ? (
                        
//                         <select
//                           value={editedData[header] || ""}
//                           onChange={(e) => handleChange(e, header)}
//                           className="w-full p-1 border text-black"
//                         >
                            
//                           <option value="" disabled>
//                             Select an option
//                           </option>
//                           {vTypeData?.result?.map((option, i) => (
//                             <option key={i} value={option?.title}>
//                               {option?.title}
//                             </option>
//                           ))}
//                         </select>
//                       ) :  header === "category" ? (
                        
//                         <select
//                           value={editedData[header] || ""}
//                           onChange={(e) => handleChange(e, header)}
//                           className="w-full p-1 border text-black"
//                         >
                            
//                           <option value="" disabled>
//                             Select an option
//                           </option>
//                           {categoryData?.result?.map((option, i) => (
//                             <option key={i} value={option.title}>
//                               {option.title}
//                             </option>
//                           ))}
//                         </select>
//                       ): header === "subCategory" ? (
                        
//                         <select
//                           value={editedData[header] || ""}
//                           onChange={(e) => handleChange(e, header)}
//                           className="w-full p-1 border text-black"
//                         >
                            
//                           <option value="" disabled>
//                             Select an option
//                           </option>
//                           {subCategoryData?.result?.map((option, i) => (
//                             <option key={i} value={option.title}>
//                               {option.title}
//                             </option>
//                           ))}
//                         </select>
//                       ): ["is_active", "editable", "optional", "is_option", "is_countryOption"].includes(header) ? (
//                         <div className="cursor-pointer flex justify-center">
//                           {editedData[header] === true && (
//                             <FontAwesomeIcon
//                               onClick={(e) => handleChange(e, header, true)}
//                               color="var(--green_Main)"
//                               icon={faCheck}
//                             />
//                           )}
//                           {editedData[header] === false && (
//                             <FontAwesomeIcon
//                               onClick={(e) => handleChange(e, header, false)}
//                               color="indianred"
//                               icon={faXmark}
//                             />
//                           )}
//                         </div>
//                       ) : (
//                         <input
//                           type="text"
//                           value={editedData[header] || ""}
//                           onChange={(e) => handleChange(e, header)}
//                           onKeyUp={(e) => e.key === "Enter" && handleSave()}
//                           className="w-full p-1 border text-black"
//                         />
//                       )
//                     ) : header === "Question_title_translation"  && typeof row[header] === "object" ? (
//                       <div
//                         className="cursor-pointer flex items-center"
//                         onClick={() => handleTranslation(row[header], row.id)}
//                       >
//                         View Title Translations
//                         <FontAwesomeIcon className="ml-2" icon={faLanguage} />
//                       </div>
//                     ):header==="Temp_Record" ? (<div className="cursor-pointer" onClick={()=>handleTempRecord(row)}>
//                     View Temp Record <FontAwesomeIcon icon={faEye}/>
//                     </div>):header==="countryOptionList" ? (<>
//              <div
//                           className="cursor-pointer flex items-center text-nowrap"
//                         >
//                           {(row.is_option && row.variableType==="Single" || row.variableType==="Multi") ?  <div onClick={() => handleCountryOptionList(row, row.id)} className="">View Option Lists <FontAwesomeIcon icon={faList} /> </div>:<></>}
//                         </div>
//                     </>): header === "Question_Subtitle_translation"  && typeof row[header] === "object" ? (
//                         <div
//                           className="cursor-pointer flex items-center"
//                           onClick={() => handleSubTitleTranslation(row[header], row.id)}
//                         >
//                           View Subtitle Translations
//                           <FontAwesomeIcon className="ml-2" icon={faLanguage} />
//                         </div>
//                       ): header === "option_List"  && typeof row[header] === "object" ? (
//                         <div
//                           className="cursor-pointer flex items-center text-nowrap"
//                         >
//                           {(row.variableType==="Single" || row.variableType==="Multi") ?  <div onClick={() => handleOptionList(row[header], row.id)} className="">View Option Lists <FontAwesomeIcon icon={faList} /> </div>:<></>}
                         
                      
                         
//                         </div>
//                       ) : row[header] === true ? (
//                       <FontAwesomeIcon className="ml-2" color="var(--green_Main)" icon={faCheck} />
//                     ) : row[header] === false ? (
//                       <FontAwesomeIcon className="ml-2" color="indianred" icon={faXmark} />
//                     ) : (
//                       String(row[header])
//                     )}
//                   </td>
//                 ))}
//                 {editable &&   <td className="border sticky right-0 bg-white z-1">
//                   {editRowId === row.id ? (
//                     <div className="flex justify-center">
//                       <FontAwesomeIcon
//                         className="p-2 cursor-pointer"
//                         color="#67a97b"
//                         onClick={handleSave}
//                         icon={faSave}
//                       />
//                       <FontAwesomeIcon
//                         className="p-2 cursor-pointer"
//                         color="indianred"
//                         onClick={handleCancel}
//                         icon={faXmark}
//                       />
//                     </div>
//                   ) : (
//                     <div className="flex justify-center">
//                       <FontAwesomeIcon
//                         className="cursor-pointer"
//                         onClick={() => handleEdit(row.id)}
//                         icon={faPenToSquare}
//                       />
//                       <FontAwesomeIcon
//                         className="ml-2 cursor-pointer"
//                         onClick={() => handleLog(row.id)}
//                         icon={faFileLines}
//                       />
//                        <FontAwesomeIcon
//                         className="ml-2 cursor-pointer"
//                         onClick={() => handleview(row.id)}
//                         icon={faEye}
//                       />
//                     </div>
//                   )}
//                 </td>}
              
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <Modal
//         isOpen={transDis}
//         onClose={() => setTransDis(false)}
//         title="Question title translations"
//         content={<QuestionTitleTrans currLang={transData} langList={languageList?.data?.result} editable={editable}  />}
//       />


// <Modal
//         isOpen={subTitleTransDis}
//         onClose={() => setSubTitleTransDis(false)}
//         title="Question Sub title translations"
//         content={<QuestionSubTitleTrans currLang={transData} langList={languageList?.data?.result} editable={editable}  />}
//       />


//       <Modal
//         isOpen={optionMod}
//         onClose={() => setOptionMod(false)}
//         title="Options list"
//         content={<OptionList currOptions={currOptionData} editable={editable} />}
//       />

//       <Modal
//       isOpen={cOptionsDis}
//       onClose={()=>setCoptionsDis(false)}
//       // title="Country Specific Options List"
//       content={<CountryOptionList rowData={currRow} editable={editable} />}
//       />


//     <Modal
//       isOpen={tempDis}
//       onClose={()=>setTempDis(false)}
//       title="Temp Records"
//       content={<TempRecordPopUp rowData={tempRecord} editable={editable}/>}
//     />

//     </>
//   );
// };

// export default EditableTable;



import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/Modal";
import TempRecordPopUp from "./TempRecord";

const EditableTable = ({ rows, handleview, editable }) => {
  const [tempRecord, setTempRecord] = useState();
  const [tempDis, setTempDis] = useState(false);

  // ✅ Keys you DON'T want in table
  const HIDDEN_KEYS = [
    "option_List",
    "Question_Subtitle_translation",
    "Question_title_translation",
    "Question_title",
    "Question_Subtitle",
    "is_active",
    "optional",
    "editable",
    "is_countryOption",
    "is_option",
    "countryOptionList",
    "createdBy",
    "id", // optional hide
  ];

  // ✅ Generate headers dynamically (filtered)
  const headers =
    rows?.length > 0
      ? Object.keys(rows[0]).filter((key) => !HIDDEN_KEYS.includes(key))
      : [];

  // ✅ Temp modal handler
  const handleTempRecord = (row) => {
    setTempRecord({ id: row.id, tempData: row.Temp_Record });
    setTempDis(true);
  };

  return (
    <>
      <div className="tableContainer overflow-x-auto max-h-[80vh] min-h-[300px] border">
        <table className="table text-xs w-full border-collapse">

          {/* ✅ Sticky Header */}
          <thead className="sticky top-0 bg-[var(--mainCol)] text-white z-10">
            <tr>
              {headers.map((header) => (
                <th key={header} className="p-2 text-left border">
                  {header.toUpperCase()}
                </th>
              ))}

              {editable && (
                <th className="p-2 text-center border sticky right-0 bg-[var(--mainCol)] z-20">
                  ACTION
                </th>
              )}
            </tr>
          </thead>

          <tbody>
            {rows?.map((row) => (
              <tr key={row.id}>

                {headers.map((header) => (
                  <td key={header} className="p-3 border text-left text-nowrap">

                    {/* ✅ Temp Record special case */}
                    {header === "Temp_Record" ? (
                      <div
                        className="cursor-pointer text-blue-600"
                        onClick={() => handleTempRecord(row)}
                      >
                        Temp Record
                      </div>
                    ) : (
                      row[header] // ✅ simple value render
                    )}

                  </td>
                ))}

                {/* ✅ Only Eye button */}
                {editable && (
                  <td className="border text-center sticky right-0 bg-white z-1">
                    <FontAwesomeIcon
                      icon={faEye}
                      className="cursor-pointer"
                      onClick={() => handleview(row.id)}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>

        </table>
      </div>

      {/* ✅ Temp Record Modal */}
      <Modal
        isOpen={tempDis}
        onClose={() => setTempDis(false)}
        title="Temp Records"
        content={
          <TempRecordPopUp
            rowData={tempRecord}
            editable={editable}
          />
        }
      />
    </>
  );
};

export default EditableTable;